'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import BeforeBeginPortal from 'ContentEditorUI/components/portals/BeforeBeginPortal';
import UIFireAlarm from 'UIComponents/alert/UIFireAlarm';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsReadOnlyModeForCritsit, getIsPublishDisabledForCritsit } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getContentTypeSlug } from 'ContentEditorUI/redux/selectors/contentTypeSelector';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => {
  return {
    isReadOnlyModeForCritsit: getIsReadOnlyModeForCritsit(state),
    publishDisabled: getIsPublishDisabledForCritsit(state),
    contentType: getContentTypeSlug(state)
  };
};
class ReadOnlyFireAlarm extends Component {
  render() {
    const {
      isReadOnlyModeForCritsit,
      publishDisabled
    } = this.props;
    if (isReadOnlyModeForCritsit || publishDisabled) {
      let {
        contentType
      } = this.props;
      if (contentType === 'landingPage' || contentType === 'sitePage') {
        contentType = 'pages';
      } else if (contentType === 'staging') {
        contentType = 'blog';
      }
      const title = isReadOnlyModeForCritsit ? 'app.readOnly.title' : 'app.publishDisabled.title';
      const message = isReadOnlyModeForCritsit ? 'app.readOnly.message' : `app.publishDisabled.message.${contentType}`;
      return /*#__PURE__*/_jsx(BeforeBeginPortal, {
        id: 'read-only-fire-alarm-container',
        targetElement: document.getElementsByClassName('page')[0],
        children: /*#__PURE__*/_jsx(UIFireAlarm, {
          type: "danger",
          id: "read-only-fire-alarm",
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: title
          }),
          children: /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: message
            })
          })
        })
      }, 'read-only-fire-alarm-container');
    }
    return null;
  }
}
ReadOnlyFireAlarm.propTypes = {
  isReadOnlyModeForCritsit: PropTypes.bool.isRequired,
  publishDisabled: PropTypes.bool.isRequired,
  contentType: PropTypes.string.isRequired
};
export default connect(mapStateToProps)(ReadOnlyFireAlarm);